import { LateTimeType, OfficialReportType } from '@/types/officialReport'

export const getLateReportTypeLabel = (reportType: OfficialReportType, timeType?: LateTimeType): string => {
    const lateTimeLabel = reportType === OfficialReportType.LateTakeover ? 'Takeover' : 'Departure'
    const defaultLabel = `${lateTimeLabel} time`
    const takeoverTimeLabel = !timeType
        ? defaultLabel
        : timeType === LateTimeType.Given
          ? `Given ${defaultLabel.toLowerCase()}`
          : `Scheduled  ${defaultLabel.toLowerCase()}`

    return takeoverTimeLabel
}
